import { styled } from '@mui/material';

export const BaseSiteMap = styled('div')(() => ({
  padding: '56px 0px',
  backgroundColor: 'var(--color-background-primary)',
}));

export const AssistantMessageContainer = styled('div')(() => ({
  marginBottom: '24px',
  maxWidth: '800px',
}));

export const LinkItem = styled('li')(() => ({
  marginBottom: '4px',
  color: 'var(--color-app-primary-300)',
  marginLeft: '50px',

  '& a': {
    color: 'var(--color-app-primary-300)',
    fontSize: '18px',
    fontWeight: '500',
    textDecoration: 'none',
    transition: 'color 0.3s ease-in-out',

    '&:hover': {
      color: 'var(--color-app-primary-500)',
    },
  },

  '& ul': {
    marginTop: '8px',
    paddingLeft: '20px',

    '& li': {
      marginBottom: '8px',
      listStyleType: 'disc',

      '& a': {
        fontSize: '18px',
      },
    },
  },
}));
